import { render, staticRenderFns } from "./MbInput.vue?vue&type=template&id=9c5078fa&"
import script from "./MbInput.vue?vue&type=script&lang=js&"
export * from "./MbInput.vue?vue&type=script&lang=js&"
import style0 from "./MbInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports